import { render, staticRenderFns } from "./BranchOverview.vue?vue&type=template&id=13ac3a62&scoped=true"
import script from "./BranchOverview.vue?vue&type=script&lang=js"
export * from "./BranchOverview.vue?vue&type=script&lang=js"
import style0 from "./BranchOverview.vue?vue&type=style&index=0&id=13ac3a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac3a62",
  null
  
)

export default component.exports